import React from "react";
import { Moon, Heart, Sparkles, Globe } from "lucide-react";
import { ASSETS } from "@/lib/content";
import MoonDivider from "@/components/MoonDivider";

const VALUES = [
  { icon: Sparkles, title: "Artisan Crafted", text: "Every piece is hand-sculpted in small batches using premium cacao and the finest ingredients." },
  { icon: Heart, title: "Proudly Inclusive", text: "We celebrate all adult love. Whoever you are, whoever you desire — you belong here." },
  { icon: Globe, title: "Discreet Worldwide", text: "Elegantly, privately packaged and shipped internationally so pleasure knows no borders." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative bg-noir flex items-center justify-center py-14 sm:py-20 px-6 border-b border-white/10" data-testid="about-hero">
        <img
          src={ASSETS.banner}
          alt="After Dark Chocolates"
          className="w-full max-w-2xl object-contain mix-blend-screen"
        />
      </section>

      <section className="max-w-3xl mx-auto px-6 py-20 text-center">
        <MoonDivider label="Our Story" />
        <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-8 mb-6 leading-tight">
          Born of desire, sculpted after dark
        </h1>
        <p className="font-serif italic text-2xl text-gold/90 mb-8">
          "Sinfully sculpted for your naughty pleasure"
        </p>
        <div className="font-body text-white/60 leading-relaxed space-y-5 text-left">
          <p>
            After Dark Chocolates began with a simple, wicked idea: that chocolate should be as sensual as the moments it accompanies. We craft luxury adult novelty confections for grown-ups who aren't afraid to indulge their appetites — for taste, for beauty, and for pleasure.
          </p>
          <p>
            Each creation is hand-sculpted by our chocolatiers using deep, rich dark chocolate and rare ingredients, then presented in packaging as elegant as it is discreet. Whether you're treating yourself or seducing someone special, our chocolates are made for the hours after the sun goes down.
          </p>
          <p>
            We are, above all, a brand for everyone. Love is love, desire is desire, and every adult deserves a little decadence. We stand proudly with the LGBT community and craft our confections to celebrate all relationships, all bodies, and all forms of pleasure.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {VALUES.map((v) => (
            <div key={v.title} className="border border-white/10 bg-noir-2 p-8 text-center" data-testid={`value-${v.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <v.icon className="w-8 h-8 text-gold mx-auto mb-5" strokeWidth={1.3} />
              <h3 className="font-serif text-2xl text-cream mb-3">{v.title}</h3>
              <p className="font-body text-sm text-white/55 leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
